export const userProfile = {
  username: "Username",
  myProfile: "My Profile",
  myCompany: "My Company",
  detailedDescription: "Detailed Description",
  myAccount: "My Account",
  uploadPhoto: "Upload Photo",
  deleteProfile: "Delete Profile?",
  areYouSureDeleteProfile:
    "Are you sure you want to delete your profile? This action cannot be undone. All your data will be deleted and you will not be able to recover it.",
  profileDeletedSuccessfully: "Profile deleted successfully",
  errorDeletingProfile: "Error deleting profile. Please try again.",
  contactInfo: "Contact Information",
  personalInfo: "Personal Information",
  mobilePhone: "Mobile Phone",
  telephone: "Telephone",
  // ===============================================================
};
